import React from "react";

interface PagesIconProps {
  isActive?: boolean;
}

export const PagesIcon: React.FC<PagesIconProps> = ({ isActive = false }) => {
  const color = isActive ? "var(--active-color)" : "#83829D";

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="10"
        height="14"
        rx="1.5"
        stroke={color}
        strokeWidth="1.3"
      />
      <path
        d="M7 7H11"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M7 10H11"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M7 13H10"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M9.5 5.5H16C16.8284 5.5 17.5 6.17157 17.5 7V17.5"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9H17"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M12.5 12H17"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M12.5 15H17"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};


